import type { Ref } from 'vue';
import { useMsal } from './useMsal';
import { eagerComputed } from '@vueuse/core';

export function useIsAuthenticated(): Readonly<Ref<boolean>> {
    const { accounts } = useMsal();

    return eagerComputed(() => accounts.value.length > 0);
}
